import { useSearchParams } from '@remix-run/react';
import { useEffect } from 'react';

const useRemoveParams = (params: string[]) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let updated = false;

    params.forEach((param) => {
      if (searchParams.has(param)) {
        searchParams.delete(param);
        updated = true;
      }
    });

    if (updated) {
      setSearchParams(searchParams, { replace: true });
    }
  }, [params, searchParams, setSearchParams]);
};

export default useRemoveParams;
